import {Extent, getArea} from 'ol/extent.js';

export * from './compare.ts';
export * from './labs.ts';
export * from './local-storage.ts';
export * from './modals.ts';
export * from './mosaics.js';
export * from './orders.ts';
export * from './preferences.ts';
export * from './processes.ts';
export * from './sort.ts';

export const ITEM_COUNT_LIMIT = 100;
export const DEFAULT_ZOOM = 2;
export const DRAG_TYPE = 'Text';
export const MAX_FULL_ACCESS_ZOOM = 15; // highest resolution basemap tiles available
export const MAX_HIGH_RES_LIMITED_ACCESS_ZOOM = 13; // SkySat tiles outside constraint geometry stop here
export const MAX_ZOOM = 20; // map stops here
export const MAX_LIMITED_ACCESS_ZOOM = 10; // SS tiles outside constraint geometry stop here

/** Downsampling Limits */
export const DOWNSAMPLE_ZOOM = 11;
export const DOWNSAMPLE_THRESHOLD = 0.25;

export const MAX_TILESET_ITEMS = 30;
export const MAX_VISIBLE_RESULTS = 10;

export const MAX_GEOMETRY_AREA = 50000; // Maximum area in square km

export const UI_MODES = {
  BROWSE: 'browse',
  COMPARE: 'compare',
  SNAPSHOT: 'snapshot',
  PIXEL_PROVENANCE: 'pixelProvenance',
} as const;
export type UiModesValueType = (typeof UI_MODES)[keyof typeof UI_MODES];

export const SERIES_DELIM = '.';

export const DEFAULT_PROCESS = 'rgb';

export const GEO_PROJECTION = 'EPSG:4326';
export const WEB_PROJECTION = 'EPSG:3857';
export const UTM_PROJECTION = 'UTM';

export const PROJECTION_LABELS = {
  3857: 'Web Mercator (EPSG: 3857)',
  4326: 'World Geodetic System (EPSG: 4326)',
  UTM: 'UTM (auto zone)',
} as const;

export const DRAWERS = {
  SEARCH: 'search-drawer',
  ORDERS: 'orders-drawer',
  SETTINGS: 'settings-drawer',
  COLORENHANCE: 'colorenhance-drawer',
  PROCESS: 'process-drawer',
  SAVED_SEARCHES: 'saved-searches-drawer',
  COLLECTIONS: 'collections-drawer',
  ANALYTICAL_DOWNLOAD: 'analytical-download-drawer',
} as const;

export type DrawersValueType = (typeof DRAWERS)[keyof typeof DRAWERS];

export const CONTACT_SALES_URL =
  'https://learn.planet.com/contact-us-explorer.html';

// Trials
export const EVALUATION_PROGRAM_ID = 29;

export const INFINITE_QUOTA_CAP = Math.pow(2, 31) - 1;

export const MAP_TOOLS = {
  DRAW_LOCKED_CIRCLE: 'draw-locked-circle',
  DRAW_LOCKED_RECT: 'draw-locked-rect',
  DRAW_RECT_SUPER_RES: 'draw-rect-super-res',

  DRAW_POLYGON: 'draw-polygon',
  DRAW_CIRCLE: 'draw-circle',
  DRAW_RECT: 'draw-rect',
  DRAW_LINE: 'draw-line',

  EDIT: 'draw-edit',

  NONE: '',
} as const;

export const MAP_DRAW_LAYERS = {
  GEOMETRY: 'geometry',
  MEASURE: 'measure',
  NONE: 'none',
} as const;

export const WORLD_EXTENT = [-180, -90, 180, 90] as Extent;
export const WORLD_EXTENT_AREA = getArea(WORLD_EXTENT);

export const MAX_VERTEX_COUNT = 1500;
